<template>
  <footer>
    <ul class="social-icon">
      <li class=""><a target="_blank" href="https://www.facebook.com/diu.net.bd" class=""><i
            class="fab fa-facebook-square"></i></a></li>
      <li class=""><a target="_blank" href="https://www.youtube.com/diudhaka" class=""><i
            class="fab fa-youtube"></i></a></li>
      <li class=""><a target="_blank" href="https://twitter.com/diubd" class=""><i
            class="fab fa-twitter-square"></i></a></li>
      <li class=""><a target="_blank" href="https://www.linkedin.com/edu/dhaka-international-university-10307"
          class=""><i class="fab fa-linkedin"></i></a></li>
      <li class=""><a target="_blank" href="https://www.instagram.com/diu.net.bd" class=""><i
            class="fab fa-instagram"></i></a></li>
      <li class=""><a target="_blank" href="https://plus.google.com/u/0/+DhakaInternationalUniversity" class=""><i
            class="fab fa-google-plus-square"></i></a></li>
      <li class=""><a target="_blank" href="https://www.pinterest.com/DIUdhaka" class=""><i
            class="fab fa-pinterest-square"></i></a></li>
    </ul>
    <div class="container text-center">
      <div class="d-flex justify-content-center align-items-center flex-wrap px-3 py-2 ">
        <span class="fw-semibold text-primary mx-2">Today's Visitor: {{ visitor.today_count }}</span>
        <span class="fw-semibold text-success mx-2">Last 30 Day's Visitor: {{ visitor.last30days_count }}</span>
        <span class="fw-semibold text-danger mx-2">Total Visitor: {{ visitor.total_count }}</span>
      </div>
    </div>

    <div class="diu-footer-copyright text-center text-light">
      <p>© {{ new Date().getFullYear() }} <span class="text-success">DIU International Theme</span>. All Rights
        Reserved. Powered by <a href="http://it.diu.ac/" class="text-muted text-uppercase" target="_blank">IT Team –
          DIU</a></p>
    </div>
  </footer>
</template>
<script>


export default {

  data() {
    return {
      visitor: '',
    };
  },
  name: "App",


  mounted() {
    this.visitorTracker();

  },

  methods: {

    visitorTracker() {
      const url = window.location.href;
      axios.post('https://diu.ac/api/profile-visitor-tracking', { url })
        .then(response => {
          this.visitor = response.data.count;
        })
        .catch(error => {
          console.error('Error tracking visitor:', error);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue